import { formHasOpeningHours } from '@/helpers/availabilityHelpers'
import { RegistrationFormKeys, RegistrationFormModel } from '@/types/registration-data'
import { DepartmentType } from '@/types/questions'

export const hasOperationsDepartment = (departmentTypes: DepartmentType[]): boolean => {
    return departmentTypes.includes(DepartmentType.OPERATIONS)
}

export const formHasChain = (formData: Partial<RegistrationFormModel> | null | undefined): boolean => {
    if (!formData) return false

    return !!formData[RegistrationFormKeys.CHAIN] || !!formData[RegistrationFormKeys.CHAIN_FULL_NAME]
}

const formHasPickupAddress = (formData: Partial<RegistrationFormModel> | null | undefined): boolean => {
    if (!formData) return false

    return formData[RegistrationFormKeys.IS_PICKUP] === false || !!formData[RegistrationFormKeys.PICKUP_POSTAL_CODE]
}

/**
 * Determines if the registration form implies the registration concerns the operations department.
 * This is used to determine if certain fields should be shown in the registration form.
 */
export const registrationFormImpliesOperations = (
    formData: Partial<RegistrationFormModel> | null | undefined,
): boolean => {
    return formHasChain(formData) || formHasOpeningHours(formData) || formHasPickupAddress(formData)
}
